/* Mount Grain theme — core interactivity (vanilla JS, no dependencies) */
(function () {
  'use strict';

  /* ---------- Mobile nav ---------- */
  var burger = document.querySelector('[data-mobile-nav-open]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileNavClose = document.querySelector('[data-mobile-nav-close]');
  function toggleMobileNav(open) {
    if (!mobileNav) return;
    mobileNav.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger) burger.addEventListener('click', function () { toggleMobileNav(true); });
  if (mobileNavClose) mobileNavClose.addEventListener('click', function () { toggleMobileNav(false); });

  /* ---------- Announcement bar rotation ---------- */
  (function () {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;
    var wrap = bar.querySelector('[data-announcement-slides]');
    if (!wrap) return;
    var slides = wrap.querySelectorAll('[data-announcement-slide]');
    if (slides.length < 2) return;

    var cur = 0;
    var timer = null;
    var speed = parseInt(wrap.getAttribute('data-autoplay-speed'), 10) || 4000;

    function goTo(idx) {
      slides[cur].classList.remove('is-active');
      cur = (idx + slides.length) % slides.length;
      slides[cur].classList.add('is-active');
    }

    function next() { goTo(cur + 1); }
    function prev() { goTo(cur - 1); }

    function startTimer() {
      if (timer) clearInterval(timer);
      timer = setInterval(next, speed);
    }

    function stopTimer() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    startTimer();

    bar.addEventListener('mouseenter', stopTimer);
    bar.addEventListener('mouseleave', startTimer);

    var prevBtn = bar.querySelector('[data-announcement-prev]');
    var nextBtn = bar.querySelector('[data-announcement-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        prev();
        startTimer();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        next();
        startTimer();
      });
    }

    var startX = 0;
    wrap.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      stopTimer();
    }, { passive: true });

    wrap.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 40) {
        if (diff < 0) next();
        else prev();
      }
      startTimer();
    }, { passive: true });
  })();

  /* ---------- Hero / product thumbnail galleries ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    var index = 0;

    function show(idx) {
      if (idx < 0) idx = thumbs.length - 1;
      if (idx >= thumbs.length) idx = 0;
      index = idx;
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      var src = thumbs[idx].getAttribute('data-full-src');
      if (main && src) {
        var img = main.querySelector('img');
        if (img) img.setAttribute('src', src);
      }
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
    });
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('[data-faq-item]').forEach(function (item) {
    var question = item.querySelector('[data-faq-question]');
    var answer = item.querySelector('[data-faq-answer]');
    if (!question || !answer) return;
    question.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      item.closest('[data-faq-list]').querySelectorAll('[data-faq-item]').forEach(function (other) {
        other.classList.remove('is-open');
        other.querySelector('[data-faq-answer]').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  /* ---------- Quantity selector ---------- */
  document.querySelectorAll('[data-quantity-selector]').forEach(function (sel) {
    var input = sel.querySelector('input');
    var minus = sel.querySelector('[data-quantity-minus]');
    var plus = sel.querySelector('[data-quantity-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
    if (plus) plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---------- Bundle / quantity tier selector ---------- */
  document.querySelectorAll('[data-bundle-tiers]').forEach(function (wrap) {
    var tiers = wrap.querySelectorAll('[data-bundle-tier]');
    var qtyInput = document.querySelector('[data-quantity-selector] input');
    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        tiers.forEach(function (t) { t.classList.remove('is-selected'); });
        tier.classList.add('is-selected');
        var qty = tier.getAttribute('data-qty');
        if (qtyInput && qty) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event('change'));
        }
      });
    });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (cartDrawer) { e.preventDefault(); openCartDrawer(); }
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCartDrawer);
  });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  function refreshCartDrawer() {
    if (!cartDrawer) return;
    fetch('/cart?view=drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        if (fresh) {
          cartDrawer.innerHTML = fresh.innerHTML;
          bindCartDrawerEvents();
        }
      })
      .catch(function () {});
  }

  function bindCartDrawerEvents() {
    if (!cartDrawer) return;
    cartDrawer.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', closeCartDrawer);
    });
    cartDrawer.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var key = btn.getAttribute('data-cart-remove');
        updateCartLine(key, 0);
      });
    });
  }
  bindCartDrawerEvents();

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function updateCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        refreshCartDrawer();
      })
      .catch(function () {});
  }

  /* ---------- Add to cart (AJAX) ---------- */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.setAttribute('disabled', 'disabled'); submitBtn.textContent = 'Adding…'; }

      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (cartDrawer) {
            refreshCartDrawer();
            openCartDrawer();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          window.location.href = '/cart';
        })
        .finally(function () {
          if (submitBtn) { submitBtn.removeAttribute('disabled'); submitBtn.textContent = originalText; }
        });
    });
  });

  /* ---------- Newsletter form (basic UX only, Shopify handles submission) ---------- */
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.textContent = 'Subscribing…';
    });
  });
})();
